/*! @hebcal/hdate v0.22.2, distributed under GPLv2 https://www.gnu.org/licenses/gpl-2.0.txt */
var poAshkenazi = { "headers": { "plural-forms": "nplurals=2; plural=(n > 1);", "language": "en_CA@ashkenazi" }, "contexts": { "": { "Tevet": ["Teves"] } } };

export { poAshkenazi as default };
//# sourceMappingURL=ashkenazi.po.js.map
